import React from "react";
import { Route, Navigate, Routes } from "react-router-dom";
import CryptoJS from 'crypto-js';
import Overview from "../../Pages/Overview/Overview"
import Complaints from "../../Pages/Complaints/Complaints"
import IncentiveManagement from "../../Pages/Incentive Mangement/Incentive"
import Services from "../../Pages/Services/Service"
import CustomerPaymentHistory from "../../Pages/Customer Payment History/CustomerPyamentHistory"
import Transactions from "../../Pages/Transactions/Transactions"
import Simpl from "../../Pages/SIMPL/Simpl"
import Unauthorized from "../../Pages/Unauthorized/Unauthorized";
import User from "../../Pages/Users/User";
import CustomerParameters from "../../Pages/Customer Parameters/CustomerParameters";
import ClientCredential from "../../Pages/Client Credential/clientCredential";
import Communicationchannel from "../../Pages/Communication Channel/communication";
import Mails from "../../Pages/Mails";
import Recon from "../../Pages/ReconAndSettlement/Recon";
import HelpandSupport from "../../Pages/HelpSupport/HelpSupport";
import Milestone from "../../Pages/Milestones/milestone";
import VleDetails from "../../Pages/VleDetails/vleDetails";
import VleEarnings from "../../Pages/VleEarning/vleEarning";
import AllCategory from "../../Pages/AllCategory/allCategory";
import HomeCategory from "../../Pages/HomeCategory/homeCategory";
import CategoryGroup from "../../Pages/CategoryGroup/categoryGroup";
import Reversal from "../../Pages/Reversal/Reversal";
import RefundRequest from "../../Pages/Refund/milestone";
import Logger from "../../Pages/Logger/Logger";
import decryptedModulesData from "../../utils/decryptedModulesData";

function AppRouters() {
    
    const permissions = decryptedModulesData()?.modules || [];
    return (
        <div className="AppPageConntent">
        <Routes>
            <Route path="/" element={<Overview />} />
            <Route path="/transactions" element={checkPermission( permissions, "transactions") ? <Transactions /> : <Navigate to="/unauthorized" />} />
            <Route path="/reversal" element={checkPermission( permissions, "reversal") ? <Reversal /> : <Navigate to="/unauthorized" />} />
            <Route path="/client-Credential" element={checkPermission( permissions, "transactions") ? <ClientCredential /> : <Navigate to="/unauthorized" />} />
            <Route path="/complaints" element={checkPermission( permissions, "complaints") ? <Complaints /> : <Navigate to="/unauthorized" />} />
            <Route path="/customer-payment-history" element={checkPermission( permissions, "Customer Payment History") ? <CustomerPaymentHistory /> : <Navigate to="/unauthorized" />} />
            <Route path="/simpl" element={checkPermission( permissions, "simpl") ? <Simpl /> : <Navigate to="/unauthorized" />} />
            <Route path="/users" element={checkPermission( permissions, "users") ? <User /> : <Navigate to="/unauthorized" />} />
            <Route path="/customer-parameters" element={checkPermission( permissions, "customer-parameters") ? <CustomerParameters /> : <Navigate to="/unauthorized" />} />
            <Route path="/communication-channel" element={checkPermission( permissions, "customer-parameters") ? <Communicationchannel /> : <Navigate to="/unauthorized" />} />
            <Route path="/mails" element={checkPermission( permissions, "mails") ? <Mails /> : <Navigate to="/unauthorized" />} />
            <Route path="/recon" element={checkPermission( permissions, "Recon and Settlement") ? <Recon /> : <Navigate to="/unauthorized" />} />
            <Route path="/logger" element={checkPermission( permissions, "logger") ? <Logger /> : <Navigate to="/unauthorized" />} />
           
            <Route path="/help-support" element={<HelpandSupport />} />

            {/* these all added by csc team for csc requirements */}
            <Route path="/milestones" element={checkPermission( permissions, "milestone") ? <Milestone /> : <Navigate to="/unauthorized" />} />
            <Route path="/vle-earnings" element={checkPermission( permissions, "vle earnings") ? <VleEarnings /> : <Navigate to="/unauthorized" />} />
            <Route path="/vle-details" element={checkPermission( permissions, "vle details") ? <VleDetails /> : <Navigate to="/unauthorized" />} />
            <Route path="/all-category" element={checkPermission( permissions , "all categories") ? <AllCategory /> : <Navigate to="/unauthorized" />} />
            <Route path="/home-category" element={checkPermission( permissions , "home categories") ? <HomeCategory /> : <Navigate to="/unauthorized" />} />
            <Route path="/category-group" element={checkPermission( permissions , "categories group") ? <CategoryGroup /> : <Navigate to="/unauthorized" />} />
            <Route path="/refund" element={checkPermission( permissions , "refund") ? <RefundRequest /> : <Navigate to="/unauthorized" />} />



            {/* <Route path="/incentive-management" element={checkPermission( permissions, "incentive_management") ? <IncentiveManagement/> : <Navigate to="/unauthorized" />} /> */}
            {/* <Route path="/services" element={checkPermission( permissions, "service_list") ? <Services /> : <Navigate to="/unauthorized" />} /> */}
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="*" element={<Unauthorized/>} />
        </Routes>
        </div>
    );
}

function checkPermission(permissions, requiredPermission) {

    return Array.isArray(permissions) && permissions.some(permission => permission.module.toLowerCase() === requiredPermission.toLowerCase() && permission.read);
}

export default AppRouters;
